export default __webpack_public_path__ + "static/media/black-logo.1b7a38c2.png";